import styled from 'styled-components';

import { SecondaryButton } from 'ui/button';
import { body1, heading3 } from 'ui/theme';

export const Container = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
`;

export const MessageContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const StyledTitle = styled.div`
  ${heading3};
  text-align: center;
`;

export const StyledMessage = styled.div`
  ${body1};
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
  margin-top: ${({ theme }) => theme.spacing.utils.pxToRem(9)};
  text-align: center;
`;

export const StyledSecondaryButton = styled(SecondaryButton)`
  margin-top: ${({ theme }) => theme.spacing.utils.pxToRem(17)};
`;
